/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
 */

import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {JournalEntry} from "./journalEntry-imports";

export default class ReminderJournalEntry extends JournalEntry {

	reminderId: string = null
	taskId: string = null

	constructor(note) {
		super(JournalEntryType.REMINDER);
		this.summary = note
	}

}
